import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IQuotePriceAndExpireDateProps {
  expireDate?: string | undefined;
  price?: number;
  quoteStatus: string;
}

export const QuotePriceAndExpireDate: React.FC<IQuotePriceAndExpireDateProps> = ({
  expireDate,
  price,
  quoteStatus,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box mb={{ base: 8, md: 0 }} textAlign={{ base: 'left', md: 'right' }}>
      {quoteStatus === 'QUOTE_PENDING' ? (
        <>
          <Text fontSize="large" textTransform="uppercase">
            {expireDate}
          </Text>
          {price && (
            <Text fontSize={{ base: 'h2.base', md: 'h2.base' }} fontWeight="bold">
              {price}€
            </Text>
          )}
        </>
      ) : (
        <Text fontSize="large" textTransform="uppercase">
          {t(`ACCOUNT.DOCUMENT.STATUS.${quoteStatus}`)}
        </Text>
      )}
    </Box>
  );
};
